const downdloadPhoto = (url, window, document) => {
  if (!url) throw new Error('No url provided for download');

  return fetch(url, {
    method: 'GET'
  }).then(response => response.blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', getPhotoName(url));

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
};

export const getPhotoName = (photoUrl) => {
  if (!photoUrl) throw new Error('Missing params: photoUrl');

  const photoUrlParts = photoUrl.split('/');
  const lastPhotoUrlPart = photoUrlParts[photoUrlParts.length - 1];
  return lastPhotoUrlPart.split('?')[0];
};

export default downdloadPhoto;
